import React from "react";
import { FieldGroup } from "../../../../components";

const DetailInfoEditable = ({
  data,
  possibleFeatures,
  model,
  setModel,
  dialColor,
  setDialColor,
  dialIndex,
  setDialIndex,
  braceletType,
  setBraceletType,
  size,
  setSize,
  referenceNumber,
  setReferenceNumber,
  isMobile,
}) => {
  return (
    <div
      className={`${isMobile ? "row" : "border"} detail-info border-gray-200`}
    >
      <div className={`${isMobile ? "px-1 pb-1" : ""}`}>
        <div
          className={`${
            isMobile ? "" : "border-bottom"
          } detail-item border-gray-200 col-12 col-md-12`}
        >
          {data.brand}
        </div>
      </div>

      <div
        className={`${
          isMobile ? "px-1 py-1" : "px-0 border-bottom"
        } border-gray-200 col-6 col-md-12`}
      >
        <FieldGroup
          placeholder={model ?? "Model"}
          type="select"
          options={possibleFeatures.model_name.map((item) => {
            return { id: item, name: item };
          })}
          name="model"
          value={model}
          onChange={setModel}
          noFormik
        />
      </div>
      <div
        className={`${
          isMobile ? "px-1 py-1" : "px-0 border-bottom"
        } border-gray-200 col-6 col-md-12`}
      >
        <FieldGroup
          placeholder={referenceNumber ?? "Reference Number"}
          type="text"
          name="reference_number"
          value={referenceNumber}
          onChange={(e) => setReferenceNumber(e.target.value)}
          noFormik
        />
      </div>
      <div
        className={`${
          isMobile ? "px-1 py-1" : "px-0 border-bottom"
        } border-gray-200 col-6 col-md-12`}
      >
        <FieldGroup
          placeholder={dialColor ?? "Dail Color"}
          type="select"
          options={possibleFeatures.dial_color.map((item) => {
            return { id: item, name: item };
          })}
          name="dial_color"
          value={dialColor}
          onChange={setDialColor}
          noFormik
        />
      </div>
      <div
        className={`${
          isMobile ? "px-1 py-1" : "px-0 border-bottom"
        } border-gray-200 col-6 col-md-12`}
      >
        <FieldGroup
          placeholder={braceletType ?? "Bracelet Type"}
          type="select"
          options={possibleFeatures.bracelet_type.map((item) => {
            return { id: item, name: item };
          })}
          name="bracelet_type"
          value={braceletType}
          onChange={setBraceletType}
          noFormik
        />
      </div>
      <div
        className={`${
          isMobile ? "px-1 py-1" : "px-0 border-bottom"
        } border-gray-200 col-6 col-md-12`}
      >
        <FieldGroup
          placeholder={dialIndex ?? "Dial Index"}
          type="select"
          options={possibleFeatures.dial_index.map((item) => {
            return { id: item, name: item };
          })}
          name="dial_index"
          value={dialIndex}
          onChange={setDialIndex}
          noFormik
        />
      </div>
      <div
        className={`${
          isMobile ? "px-1 py-1" : "px-0 border-bottom"
        } border-gray-200 col-6 col-md-12`}
      >
        <FieldGroup
          placeholder={size ?? "Size"}
          type="select"
          options={possibleFeatures.size.map((item) => {
            return { id: item, name: item };
          })}
          name="size"
          value={size}
          onChange={setSize}
          noFormik
        />
      </div>
    </div>
  );
};

export default DetailInfoEditable;
